// import store from '@state/store'
import { PARAMETROS } from '@src/init-globals'
import { FEATURES, MODAL, SEARCH_GROUPS } from '@constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'
import { IS_BETA_DAILY_TASKS } from '@modules/daily_tasks'
import { possivelJSON } from '@utils/Format'
import { additionalPermissions } from '@utils/AdditionalPermissions'

import routesDocuments from '@src/modules/documents/routes'
import dailyTasks from '@src/modules/daily_tasks/routes'
import routesFinance from '@src/modules/finance/routes'
import routesProfessionals from '@modules/professionals/routes'
import routesTreasury from '@src/modules/tesouraria/routes'
import routesBillingSystem from '@src/modules/billing-system/routes'
import routesPartnership from '@modules/partnership/routes'
import routesSettings from '@src/modules/settings/routes'
import routesDataRoom from '@src/modules/data-room/routes'
import routesNavegacaoV2 from '@modules/navegacao-v2/routes'
import routesBI from '@/src/modules/power-bi/routes'
import routesBoletador from '@/src/modules/boletador/routes'
import routesOpportunities from '@/src/modules/opportunities/routes'
import routesCalendar from '@/src/modules/calendar/routes'
import routesCaptable from '@/src/modules/captable/routes'
import routesCommission from '@src/modules/commissions/routes'
import routesComissoes from '@src/modules/comissoes/routes'
import routesConsolidator from '@modules/consolidator/routes'
import routesCommercial from '@/src/modules/commercial/routes'
import routesRH from '@src/modules/rh/routes'
import routesDashboard from '@modules/dashboard/routes.js'
import routesAnaliseMercado from '@modules/corretora/routes'
import routesEventos from '@modules/eventos/routes'
import routesAawzIntelligence from '@modules/aawz-intelligence/routes'
import routesBackOffice from '@modules/back-office/routes'
import routesFP from '@modules/financial-planning/routes'
import routesWS from '@modules/ws/routes.js'
import routesCrm from '@modules/crm/routes'
import routesCompliance from '@modules/compliance/routes'
import routesAawzDrive from '@modules/aawz-drive/routes'
import routesControladoriaV2 from '@modules/controladoria-v2/routes'
import routesRequisicoes from '@modules/requisicoes/routes'
import routesSolicitacoes from '@modules/solicitacoes/routes'
import routesTarefas from '@modules/tarefas/routes'
import routesDesignSystem from '@modules/design-system/routes'
import routesWorkflowEngine from '@modules/workflow-engine/routes/workflow-engine.routes'
import routesFeeFixo from '@modules/fee-fixo/routes'
import routesAiFramework from '@modules/ai-framework/routes'
import routesCentralConfig from '@modules/central-config/routes'
import routesClientJourney from '@modules/client-journey/routes'
import routesFinia from '@modules/finia/routes'
import routesProfessionalWaitlist from '@modules/professional-waitlist/routes'

const DEFAULT_HOME_ROUTE = '/carteira'

export function encontrarRota(feature_access, rotas) {
  const filterRoutes = rotas.filter((route) => {
    if (additionalPermissions[route.name]) {
      return additionalPermissions[route.name]()
    }

    return true
  })

  const item =
    filterRoutes.find((item) => {
      return feature_access[item.name] === true
    }) || {}
  // Se nenhum valor true for encontrado, retorne uma rota padrão

  return item.path || DEFAULT_HOME_ROUTE
}

export const get_home_path = () => {
  const rotas = [
    { name: 'asset-allocation', path: DEFAULT_HOME_ROUTE },
    { name: 'partnership', path: '/valuation' },
    { name: 'captable', path: '/captable' },
    { name: 'bpo-finance', path: '/financeiro' },
    { name: 'clients', path: '/clientes' },
    { name: 'daily-task', path: '/tarefas' },
    { name: 'workspace', path: '/workspace' },
    { name: 'bi-customized', path: '/bi' },
    { name: 'bi-embeded', path: '/bi-embed' },
    { name: 'treasury', path: '/tesouraria' },
    { name: 'contracts', path: '/documentos' },
    { name: 'manage-professionals', path: '/profissionais/gerenciar' },
    { name: 'products', path: '/produtos' },
    { name: 'portfolio_review', path: '/simulador' },
    { name: 'communications-client', path: '/gerenciar-vencimentos' },
    { name: 'dashboard', path: '/dashboard_profissional' },
    { name: 'services', path: '/servicos' },
    { name: 'settings', path: '/settings' },
    { name: 'boletador', path: '/boletador' },
    { name: FEATURES.COMISSOES, path: '/comissoes' },
    { name: FEATURES.OPPORTUNITIES, path: '/opportunities' },
    { name: FEATURES.TASKS, path: '/tasks' },
    { name: FEATURES.CRM, path: '/crm' },
    { name: 'news', path: '/mercado' },
    { name: 'data-room', path: '/data-room' },
    { name: 'manage-redemption', path: '/gerenciar-vencimentos' },
    { name: 'support', path: '/suporte' },
    { name: 'brokkr', path: '/comissionamento/geral' },
  ]

  const feature_access = possivelJSON(PARAMETROS.features_access || {})
  const rotaEncontrada = encontrarRota(feature_access, rotas)
  return rotaEncontrada
}

export default [
  {
    path: '/',
    name: 'home',
    meta: {
      permission: ['all'],
      parametrizar: true,
      search: {
        title: 'Home',
        description: 'Página inicial da plataforma',
        keywords: ['início', 'principal', 'home'],
        icon: 'house',
      },
    },
    // redirect: get_home_path,

    component: () =>
      lazyLoadView(import('@modules/home/views/home/view-home.vue')),
  },

  // {
  //   path: '/produtos',
  //   name: 'products',
  //   component: () => lazyLoadView(import('@views/products')),
  // },
  {
    path: '/servicos',
    name: 'servicos',
    meta: {
      permission: ['all'],
      parametrizar: true,
      can_show: FEATURES.SERVICES,
      search: {
        title: 'Serviços',
        description: 'Contratação e gestão de serviços do escritório',
        keywords: ['serviços', 'contratar', 'produtos'],
        icon: 'category',
        group: SEARCH_GROUPS.OUTROS,
      },
    },
    component: () => lazyLoadView(import('@views/profissional-servicos')),
    children: [
      {
        path: ':codigo',
        name: 'servicos.contratar',
        meta: {
          permission: ['cliente'],
          parametrizar: true,
          can_show: FEATURES.SERVICES,
        },
        component: () => lazyLoadView(import('@views/profissional-servicos')),
      },
    ],
  },
  {
    path: '/notificacoes',
    name: 'notifications',
    meta: {
      permission: ['all'],
      search: {
        title: 'Notificações',
        description: 'Central de notificações e avisos da plataforma',
        keywords: ['notificações', 'avisos', 'alertas'],
        group: SEARCH_GROUPS.OUTROS,
      },
    },
    component: () => lazyLoadView(import('@views/all-notifications')),
  },
  {
    path: '/simulador',
    name: 'simulador',
    redirect: '/simulador/',
    meta: {
      permission: ['profissional'],
      parametrizar: true,
      show_current_client: true,
      whitelabel_only: true,
      can_show: FEATURES.SIMULADOR,
      search: {
        title: 'Portfólio Review',
        description: 'Simulação e comparação de carteiras de investimento',
        keywords: ['simulador', 'portfólio', 'simulação', 'carteira'],
        icon: 'personalCard',
        group: SEARCH_GROUPS.GESTAO_PORTFOLIOS,
      },
    },
    component: () => lazyLoadView(import('@views/simulador')),
    children: [
      {
        path: '',
        name: 'simulador.selecionar',
        meta: {
          permission: ['profissional'],
          parametrizar: true,
          show_current_client: true,
          whitelabel_only: true,
          can_show: FEATURES.SIMULADOR,
        },
        component: () => lazyLoadView(import('@views/simulador-selecionar')),
      },
      {
        path: 'historico',
        name: 'simulador.historico',
        meta: {
          parametrizar: true,
          permission: ['profissional'],
          show_current_client: true,
          whitelabel_only: true,
          can_show: FEATURES.SIMULADOR,
        },
        component: () => lazyLoadView(import('@views/simulador-historico')),
      },
      {
        path: 'manual',
        name: 'simulador.manual',
        meta: {
          permission: ['profissional'],
          parametrizar: true,
          show_current_client: true,
          whitelabel_only: true,
          can_show: FEATURES.SIMULADOR,
        },
        component: () => lazyLoadView(import('@views/simulador-manual')),
      },
      {
        path: 'automatico',
        name: 'simulador.automatico',
        meta: {
          permission: ['profissional'],
          parametrizar: true,
          guiado: false,
          avancado: false,
          show_current_client: true,
          whitelabel_only: true,
          can_show: FEATURES.SIMULADOR,
        },
        component: () => lazyLoadView(import('@views/simulador-automatico')),
      },
      {
        path: 'guiado',
        name: 'simulador.guiado',
        meta: {
          permission: ['profissional'],
          parametrizar: true,
          guiado: true,
          avancado: true,
          show_current_client: true,
          whitelabel_only: true,
          can_show: FEATURES.SIMULADOR,
        },
        component: () => lazyLoadView(import('@views/simulador-guiado')),
      },
      {
        path: 'avancado',
        name: 'simulador.avancado',
        meta: {
          permission: ['profissional'],
          parametrizar: true,
          guiado: false,
          avancado: true,
          show_current_client: true,
          whitelabel_only: true,
          can_show: FEATURES.SIMULADOR,
        },
        component: () => lazyLoadView(import('@views/simulador-avancado')),
      },
      {
        path: 'analise',
        name: 'simulador.analise',
        meta: {
          permission: ['profissional'],
          parametrizar: true,
          show_current_client: true,
          whitelabel_only: true,
          can_show: FEATURES.SIMULADOR,
        },
        component: () => lazyLoadView(import('@views/simulador-analise')),
      },
      {
        path: 'comparativo',
        name: 'simulador.comparativo',
        meta: {
          permission: ['profissional'],
          parametrizar: true,
          show_current_client: true,
          whitelabel_only: true,
          can_show: FEATURES.SIMULADOR,
        },
        component: () => lazyLoadView(import('@views/simulador-comparativo')),
      },
    ],
  },
  {
    path: '/produtos',
    name: 'produtos',
    meta: {
      permission: ['profissional'],
      can_show: FEATURES.PRODUCTS,
      search: {
        title: 'Educacional',
        description: 'Conteúdos educacionais e materiais para clientes',
        keywords: ['educacional', 'produtos', 'conteúdo', 'materiais'],
        icon: 'document-text',
        group: SEARCH_GROUPS.OUTROS,
      },
    },
    component: () => lazyLoadView(import('@views/produtos')),
  },
  {
    path: '/contas',
    name: 'contas',
    meta: {
      permissions: ['cliente'],
      parametrizar: true,
      search: {
        title: 'Contas',
        description: 'Listagem das contas do cliente',
        keywords: ['contas', 'cadastro', 'listagem'],
      },
    },
    component: () => lazyLoadView(import('@views/listar-contas')),
  },
  {
    path: '/clientes',
    name: 'clientes',
    meta: {
      permission: ['profissional'],
      parametrizar: true,
      can_show: FEATURES.CLIENTS,
      search: {
        title: 'Clientes',
        description: 'Listagem e controle de clientes do escritório',
        keywords: ['clientes', 'carteira', 'contas', 'cadastro'],
        icon: 'profile-circular-frame',
        group: SEARCH_GROUPS.GESTAO_PORTFOLIOS,
        actions: [
          {
            id: 'cadastrar-cliente',
            title: 'Cadastrar cliente',
            keywords: ['novo cliente', 'criar cliente', 'adicionar cliente'],
            modal: MODAL.CADASTRAR_CLIENTES,
            modalPayload: true,
          },
        ],
      },
    },
    component: () => lazyLoadView(import('@views/controle-clientes')),
  },

  {
    path: '/gerenciar-vencimentos',
    name: 'assets-maturity',
    meta: {
      can_show: FEATURES.MANAGE_REDEMPTION,
      search: {
        title: 'Gerenciar Vencimentos',
        description: 'Controle de vencimentos e resgates de ativos',
        keywords: ['vencimentos', 'resgates', 'ativos', 'gerenciar'],
        icon: 'calendar',
        group: SEARCH_GROUPS.GESTAO_PORTFOLIOS,
      },
    },
    component: () =>
      lazyLoadView(
        import(
          '@modules/clients/views/assets-maturity/view-assets-maturity.vue'
        )
      ),
  },

  {
    path: '/resumo',
    name: 'resumo',
    meta: {
      permission: ['profissional'],
      parametrizar: true,
      show_current_client: true,
      whitelabel_only: true,
      can_show: FEATURES.CLIENTS,
    },
    component: () => lazyLoadView(import('@views/resumo-do-cliente')),
  },
  // ...routesDocuments, // Modulo removido do partnership, para ser atomico
  ...routesPartnership,
  ...routesClientJourney,
  ...routesBI,
  ...routesFinance,
  ...routesProfessionals,
  ...routesTreasury,
  ...routesBillingSystem,
  ...routesSettings,
  ...routesDataRoom,
  ...routesBoletador,
  ...routesOpportunities,
  ...routesCalendar,
  ...routesCaptable,
  ...routesCommission,
  ...routesComissoes,
  ...routesConsolidator,
  ...routesRH,
  ...routesDashboard,
  ...routesAnaliseMercado,
  ...routesCommercial,
  ...routesEventos,
  ...routesAawzIntelligence,
  ...routesBackOffice,
  ...routesFP,
  ...routesWS,
  ...routesCrm,
  ...routesCompliance,
  ...routesAawzDrive,
  ...routesControladoriaV2,
  ...routesRequisicoes,
  ...routesSolicitacoes,
  ...routesTarefas,
  ...routesDesignSystem,
  ...routesFeeFixo,
  ...routesCentralConfig,
  ...routesFinia,
  ...routesNavegacaoV2,
  ...routesAiFramework,
  // Lista de espera (spec-001 onboarding-v2). `meta.restrito` tira o chrome da
  // plataforma no layout; `meta.can_show` fecha a rota sem a flag.
  ...routesProfessionalWaitlist,
  {
    path: '/contrato',
    name: 'contrato',
    meta: {
      permission: ['profissional'],
      search: {
        title: 'Contrato',
        description: 'Contrato de adesão do escritório',
        keywords: ['contrato', 'adesão', 'termos'],
        group: SEARCH_GROUPS.OUTROS,
      },
    },
    component: () => lazyLoadView(import('@views/contrato-whitelabel')),
  },
  ...(IS_BETA_DAILY_TASKS
    ? [
        {
          path: '/tarefas',
          name: 'tarefas',
          meta: {
            permission: ['profissional'],
            parametrizar: true,
            can_show: FEATURES.DAILY_TASKS,
            search: {
              title: 'Tarefas do dia',
              description: 'Organização das tarefas diárias do profissional',
              keywords: ['tarefas', 'agenda', 'atividades', 'dia'],
              icon: 'calendar-check',
              group: SEARCH_GROUPS.GESTAO_PESSOAS,
            },
          },
          component: () => lazyLoadView(import('@views/tarefas-dia')),
          // component: () =>
          //   lazyLoadView(import('@modules/daily_tasks/views/daily-tasks.vue')),
        },
      ]
    : dailyTasks),
  {
    path: '/parametrizacao',
    name: 'parametrizacao',
    meta: {
      permission: ['all'],
    },
    component: () => lazyLoadView(import('@views/parametrizacao-sistema')),
    // verificar se deve acessar ou nao
  },
  {
    path: '/mercado',
    name: 'market',
    // Rota nomeada com filho default (`path: ''`) NÃO renderiza esse filho
    // quando se navega por `{ name: 'market' }` — o vue-router para no pai e a
    // tela fica em branco. O `redirect` resolve, e é o mesmo padrão das outras
    // rotas pai deste arquivo (`simulador`, `workspace`, `dashboard`).
    redirect: '/mercado/',
    meta: {
      hide_nav: true,
      can_show: FEATURES.NEWS,
      search: {
        title: 'Mercado',
        description: 'Notícias e informações de mercado',
        keywords: ['mercado', 'notícias', 'news', 'informações'],
        group: SEARCH_GROUPS.OUTROS,
      },
    },
    component: () =>
      lazyLoadView(import('@modules/news/views/nav-bar/news-nav-bar.vue')),
    children: [
      {
        path: '',
        name: 'market.news',
        component: () =>
          lazyLoadView(import('@modules/news/views/view-market-news')),
      },
    ],
  },
  {
    path: '/gerenciar_profissionais',
    name: 'gerenciar_profissionais',
    meta: {
      permission: ['gestor'],
      search: {
        title: 'Gerenciar Equipe',
        description: 'Gestão da equipe de profissionais do escritório',
        keywords: ['equipe', 'profissionais', 'gerenciar', 'time'],
        group: SEARCH_GROUPS.GESTAO_PESSOAS,
      },
    },
    component: () => lazyLoadView(import('@views/gerenciar-equipe')),
  },
  {
    path: '/workspace',
    name: 'workspace',
    redirect: '/workspace/',
    meta: {
      permission: ['profissional'],
      parametrizar: true,
      whitelabel_only: true,
      can_show: FEATURES.WORKSPACE,
      search: {
        title: 'Workspace',
        description: 'Canais de equipe e mesa digital do escritório',
        keywords: ['workspace', 'canais', 'equipe', 'mesa digital'],
        icon: 'chats',
        group: SEARCH_GROUPS.FERRAMENTAS,
      },
    },
    component: () => lazyLoadView(import('@views/workspace')),
    children: [
      {
        path: '',
        name: 'workspace.canais.equipe',
        meta: {
          parametrizar: true,
          whitelabel_only: true,
          can_show: FEATURES.WORKSPACE,
        },
        component: () => lazyLoadView(import('@views/workspace-canais-equipe')),
      },
      {
        path: 'mesa_digital',
        name: 'workspace.mesa.digital',
        redirect: '/workspace/mesa_digital/novos',
        meta: {
          parametrizar: true,
          whitelabel_only: true,
          can_show: FEATURES.WORKSPACE,
          search: {
            title: 'Mesa Digital',
            description: 'Gestão de chamados da mesa digital',
            keywords: ['mesa digital', 'chamados', 'atendimento'],
          },
        },
        component: () => lazyLoadView(import('@views/mesa-digital/index')),
        children: [
          {
            path: 'novos',
            name: 'workspace.mesa.digital.novos',
            meta: {
              parametrizar: true,
              whitelabel_only: true,
              can_show: FEATURES.WORKSPACE,
            },
            component: () =>
              lazyLoadView(import('@views/mesa-digital/chamados-novos')),
          },
          {
            path: 'abertos',
            name: 'workspace.mesa.digital.abertos',
            meta: {
              parametrizar: true,
              whitelabel_only: true,
              can_show: FEATURES.WORKSPACE,
            },
            component: () =>
              lazyLoadView(import('@views/mesa-digital/chamados-abertos')),
          },
          {
            path: 'fechados',
            name: 'workspace.mesa.digital.fechados',
            meta: {
              parametrizar: true,
              whitelabel_only: true,
              can_show: FEATURES.WORKSPACE,
            },
            component: () =>
              lazyLoadView(import('@views/mesa-digital/chamados-fechados')),
          },
        ],
      },
    ],
  },
  {
    path: '/dashboard_profissional',
    name: 'dashboard',
    redirect: '/dashboard_profissional/',
    meta: {
      permission: ['profissional'],
      parametrizar: true,
      can_show: FEATURES.DASHBOARD,
      search: {
        title: 'Dashboard',
        description: 'Painel de indicadores do profissional',
        keywords: ['dashboard', 'painel', 'indicadores', 'visão geral'],
        icon: 'presentation-chart',
        group: SEARCH_GROUPS.OUTROS,
      },
    },
    component: () => lazyLoadView(import('@views/dashboard-profissional')),
    children: [
      {
        path: '',
        name: 'dashboard.visao_geral',
        meta: {
          permission: ['profissional'],
          can_show: FEATURES.DASHBOARD,
        },
        component: () =>
          lazyLoadView(import('@views/dashboard-profissional-visao-geral')),
      },
      // {
      //   path: 'meus_servicos',
      //   name: 'dashboard.meus_servicos',
      //   component: () =>
      //     lazyLoadView(import('@views/dashboard-profissional-meus-servicos')),
      // },
    ],
  },
  {
    path: '/suporte',
    name: 'suporte',
    redirect: '/suporte/',
    meta: {
      permission: ['profissional'],
      parametrizar: true,
      can_show: FEATURES.SUPPORT,
      search: {
        title: 'Suporte',
        description: 'Central de ajuda e suporte da plataforma',
        keywords: ['suporte', 'ajuda', 'dúvidas', 'atendimento'],
        icon: 'question',
        group: SEARCH_GROUPS.OUTROS,
      },
    },
    component: () => lazyLoadView(import('@views/header-paginas-suporte')),
    children: [
      {
        path: '',
        name: 'suporte.como_fazer',
        meta: {
          permission: ['profissional'],
          can_show: FEATURES.SUPPORT,
        },
        component: () => lazyLoadView(import('@views/suporte-como-fazer')),
      },
      {
        path: 'faq',
        name: 'suporte.faq',
        meta: {
          permission: ['profissional'],
          can_show: FEATURES.SUPPORT,
          search: {
            title: 'FAQ do suporte',
            description: 'Perguntas frequentes sobre a plataforma',
            keywords: ['faq', 'dúvidas', 'perguntas', 'ajuda'],
          },
        },
        component: () => lazyLoadView(import('@views/suporte-faq')),
      },
      {
        path: 'fale_conosco',
        name: 'suporte.fale_conosco',
        meta: {
          permission: ['profissional'],
          can_show: FEATURES.SUPPORT,
          search: {
            title: 'Fale conosco',
            description: 'Canal de contato com o suporte',
            keywords: ['fale conosco', 'contato', 'suporte', 'ajuda'],
          },
        },
        component: () => lazyLoadView(import('@views/suporte-fale-conosco')),
      },
    ],
  },

  {
    path: '/design',
    name: 'design',
    redirect: '/design/',
    meta: {
      only_aawz: true,
    },
    component: () => lazyLoadView(import('@views/design/navegacao-design')),
    children: [
      {
        path: '',
        name: 'design.visao_geral',
        meta: {
          only_aawz: true,
        },
        component: () =>
          lazyLoadView(import('@views/design/design-visao-geral')),
      },
      {
        path: 'info_simples',
        name: 'design.info_simples',
        meta: {
          only_aawz: true,
        },
        component: () =>
          lazyLoadView(import('@views/design/pagina-info-simples')),
      },
      {
        path: 'tabelas',
        name: 'design.tabelas',
        meta: {
          only_aawz: true,
        },
        component: () =>
          lazyLoadView(import('@modules/design/views/tables/view-tables')),
      },
      {
        path: 'graficos',
        name: 'design.graficos',
        meta: {
          only_aawz: true,
        },
        component: () => lazyLoadView(import('@views/design/pagina-graficos')),
      },
      {
        path: 'dashboard',
        name: 'design.dashboard',
        meta: {
          only_aawz: true,
        },
        component: () =>
          lazyLoadView(import('@modules/design/views/view-dashboard.vue')),
      },
      {
        path: 'design-system',
        name: 'design.design_system',
        meta: {
          only_aawz: true,
        },
        component: () =>
          lazyLoadView(import('@modules/design/views/view-design-system.vue')),
      },
      {
        path: 'kanban',
        name: 'design.kanban',
        meta: {
          only_aawz: true,
        },
        component: () =>
          lazyLoadView(import('@modules/design/views/view-kanban.vue')),
      },
      {
        path: 'modais',
        name: 'design.modais',
        meta: {
          only_aawz: true,
        },
        component: () =>
          lazyLoadView(
            import('@modules/design/views/view-base-modal-shell.vue')
          ),
      },
    ],
  },
  ...routesDocuments,
  ...routesWorkflowEngine,
  {
    path: '/sem-acesso/:module?',
    name: 'without-access',
    component: () =>
      lazyLoadView(
        import(
          '@src/modules/global/views/view-without-access/without-access.vue'
        )
      ),
  },
  {
    path: '/extension-auth',
    name: 'extension-auth',
    meta: {
      // Deep-link da extensão: precisa ser acessível por qualquer usuário logado
      // (permission ['all']) para abrir a tela de autorização. O CRUD real dos
      // device tokens é protegido por auth no servidor.
      permission: ['all'],
    },
    component: () =>
      lazyLoadView(
        import('@modules/crm/views/extension-auth/extension-auth.vue')
      ),
  },
  {
    path: '/404',
    name: '404',
    // O 404 é feedback de erro, não tela de produto: sem allowMobile, todo
    // bloqueio de rota no celular exibiria "acesse a plataforma por um
    // computador" em vez de "não encontrada" — o usuário barrado leria a
    // mensagem errada e concluiria que a plataforma não funciona no telefone.
    meta: {
      allowMobile: true,
    },
    component: require('@views/_404').default,
    props: true,
  },
  {
    path: '*',
    redirect: '404',
  },
]
